import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class ReplacementMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams): string | undefined {
        const keyParts = params.key.split('.');
        if (params.translateService.translations[params.translateService.defaultLang]) {
            let translateObject = params.translateService.translations[params.translateService.defaultLang];
            for (let i = 0; i < keyParts.length; i++) {

                if (!translateObject.hasOwnProperty(keyParts[i])) {
                    return params.key;
                }
                translateObject = translateObject[keyParts[i]];
            }

            return `${translateObject} (${params.translateService.currentLang.toUpperCase()})`;
        }
    }
}
